import commonConstant from '../../common/_commonConstant';

export const createPayment = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_PAYMENT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_PAYMENT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updatePayment = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_PAYMENT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_PAYMENT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getPaymentDetail = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PAYMENT_DETAIL_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PAYMENT_DETAIL_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
